import { createAsyncThunk } from '@reduxjs/toolkit';
import apiCall from 'utils/api';
import { IFetchUserProfilePayload, IFetchUserPermissionsPayload } from './types'; // Correctly import IFetchUserProfilePayload

export const fetchUserProfile = createAsyncThunk(
  'user/fetchUserProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall<IFetchUserProfilePayload>('get', '/auth/profile/'); // apiCall now expects to return IFetchUserProfilePayload
      return response.data; // Return the entire IFetchUserProfilePayload data
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch user profile');
    }
  }
);

export const fetchUserPermissions = createAsyncThunk(
  'user/fetchUserPermissions',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall<IFetchUserPermissionsPayload>('get', '/auth/permissions/');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch user permissions');
    }
  }
);